import DetailLink from "@src/components/DetailLink";
import ReadOnlyDetailField from "@src/components/fields/ReadOnlyDetail";
import ReadOnlyDetails from "@src/components/ReadOnlyDetails";
import { type GQLPurchaseAdminQuery } from "@src/graphql.generated";
import Package from "@src/icons/Package";
import { type FC, type FunctionComponent, type PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface ShowPackageLinkProps {
    id: string;
}

const ShowPackageLink: FunctionComponent<PropsWithChildren<ShowPackageLinkProps>> = ({ id }) => (
    <DetailLink to={`/packages/${id}/edit`}>
        <Package />
        <FormattedMessage id="reviermanager.purchases.detail.package.link" defaultMessage="Paket zeigen" />
    </DetailLink>
);

const PackageInformation: FC<PropsWithChildren<GQLPurchaseAdminQuery>> = ({ licenceAdmin }) => {
    const intl = useIntl();
    const { name, description, type, validTimeInMonths } = licenceAdmin.package;

    return (
        <ReadOnlyDetails
            title={intl.formatMessage({ id: "reviermanager.purchases.detail.package.title", defaultMessage: "Details zum Paket" })}
            link={<ShowPackageLink id={licenceAdmin.package.id} />}
        >
            <ReadOnlyDetailField
                value={name}
                label={intl.formatMessage({ id: "reviermanager.purchases.detail.package.name", defaultMessage: "Paketname" })}
            />
            <ReadOnlyDetailField
                value={description}
                label={intl.formatMessage({ id: "reviermanager.purchases.detail.package.description", defaultMessage: "Beschreibung" })}
            />
            <ReadOnlyDetailField
                value={type}
                label={intl.formatMessage({ id: "reviermanager.purchases.detail.package.type", defaultMessage: "Typ" })}
            />
            <ReadOnlyDetailField
                value={`${validTimeInMonths} ${intl.formatMessage(
                    {
                        id: "reviermanager.purchases.detail.package.months",
                        defaultMessage: "{validTimeInMonths, plural, one {Monat} other {Monate}}",
                    },
                    { validTimeInMonths },
                )}`}
                label={intl.formatMessage({ id: "reviermanager.purchases.detail.package.validTimeInMonths", defaultMessage: "Gültig für" })}
            />
        </ReadOnlyDetails>
    );
};
export default PackageInformation;
